// extracted by mini-css-extract-plugin
export var active = "_jh-2";
export var recordingDot = "_jh-1";
export var recordingIndicator = "_jh-0";